'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './e-form-list.routes';

export class EFormListComponent {
  constructor(Auth, EFormsService, dialogs, $uibModal, $stateParams, Config, prompt) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.EFormsService = EFormsService;
    this.data = [];
    this.isAdmin = Auth.isAdminSync;
    this.prompt = prompt;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;

    this.formName = $stateParams.name;

    this.EFormsService.query(data => {
      this.systemForms = [{
        _id: 'contact',
        system: true,
        name: 'Contact Form'
      },{
        _id: 'feedback',
        system: true,
        name: 'Feedback Form'
      }];
      this.data = this.systemForms.concat(data);
    }, err => {
      console.log("Could not retrieve e-forms.")
    })
  }

  copyToClipboard(eform) {
    let path = "/e-form/" + eform._id;
    window.prompt("Link to E-Form:", path);
  }

  delete(eform) {
    var that = this;

    var eformText = "<br/><br/><p><b>"+ eform.name + "</b></p>";

    let callout = `<div class="bs-callout bs-callout-danger">
      <h4>Warning!</h4>
      When you delete this e-form, all user responses to this form won't be accessible anymore. <b>This cannot be undone!</b>
    </div>`;

    var dlg = this.dialogs.confirm("Delete E-Form?", "Do you really want to delete the e-form?" + eformText + callout);
    dlg.result.then(() => {

      that.prompt({
        title: 'Confirm deletion of E-Form',
        message: 'To finally delete it, please enter the e-form name below:',
        input: true,
        label: '',
        value: ''
      }).then(name => {

        if (eform.name == name) {
          // OK delete it
          that.EFormsService.delete({id: eform._id},
            () => {
              that.data = that.data.filter(function( obj ) {
                return obj._id !== eform._id;
              });
            },
            err => {
              alert("Could not delete e-form");
            });
        } else {
          that.dialogs.notify("Name doesn't match", "The name doesn't match the e-form you are about to delete.")
        }

      }, () => {
        // Cancel
      });

      });
  }

}

export default angular.module('conduu.eForms.eFormList', [uiRouter])
  .config(routes)
  .component('eFormList', {
    template: require('./e-form-list.html'),
    controller: EFormListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/e-form/list/e-form-list.component.js